import { of, from } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { authorizedFetch, validateResponse } from './http.js';
import { renderTemplate, replaceViewContainer } from './ui.js';
import { createAudioPlayback } from './audio-playback.js';

/**
 * Renders the ad-hoc TTS view: a dialect select, a text textarea, and a play
 * button. Clicking the button POSTs the textarea text to /tts-api/tts/:locale,
 * turns the returned audio bytes into an object URL, and plays it through the
 * shared audio-playback helper. The previous object URL is revoked before a new
 * one is set so the blob memory is not leaked across clicks.
 */
export function createTtsView() {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('tts-view');
            replaceViewContainer(root);
            let localeSelect = root.querySelector('#tts-locale');
            let textarea = root.querySelector('#tts-text');
            let playBtn = root.querySelector('.tts-play');
            let audio = root.querySelector('audio');

            let objectUrl;
            let setSrc = (src) => {
                if (objectUrl) {
                    URL.revokeObjectURL(objectUrl);
                }
                objectUrl = src;
                audio.src = src;
            };

            let load$ = of(undefined).pipe(
                switchMap(() =>
                    from(
                        authorizedFetch(
                            `/tts-api/tts/${encodeURIComponent(localeSelect.value)}`,
                            {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ text: textarea.value }),
                            }
                        )
                    )
                ),
                validateResponse(),
                switchMap((response) => from(response.blob())),
                map((blob) => URL.createObjectURL(blob))
            );

            return createAudioPlayback(playBtn, audio, load$, setSrc);
        })
    );
}
